<script>
export default {
  props: {
    currentLevel: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      levels: [
        { id: '1', name: 'VIP300', discount: '35%' },
        { id: '2', name: 'VIP500', discount: '40%' },
        { id: '3', name: 'VIP700', discount: '45%' },
        { id: '4', name: 'VIP1000', discount: '50%' },
      ]
    };
  },
  computed: {
    currentIndex() {
      if (!this.currentLevel) return -1;
      return this.levels.findIndex(l => l.id === this.currentLevel);
    },
    progressPercent() {
      if (this.currentIndex < 0) return 0;
      if (this.currentIndex >= this.levels.length - 1) return 80;
      return (this.currentIndex / (this.levels.length - 1)) * 80;
    }
  },
  methods: {
    isCompleted(index) {
      return index <= this.currentIndex;
    },
    isCurrent(index) {
      return index === this.currentIndex;
    }
  }
};
</script>

<template>
  <div class="pro-progress-wrapper">
    <div class="pro-progress-track">
      <div class="pro-progress-line-bg"></div>
      <div class="pro-progress-line-fill" :style="{ width: progressPercent + '%' }"></div>
      <div class="pro-progress-steps">
        <div
          v-for="(level, index) in levels"
          :key="level.id"
          class="pro-step"
          :class="{
            'pro-step--completed': isCompleted(index),
            'pro-step--current': isCurrent(index),
            'pro-step--pending': !isCompleted(index) && !isCurrent(index)
          }"
        >
          <div class="pro-step__node">
            <i v-if="isCompleted(index)" class="bx bx-check"></i>
            <i v-else class="bx bxs-hourglass-top" ></i>
          </div>
          <div class="pro-step__label">
            <div class="pro-step__name">{{ level.id }}</div>
            <div class="pro-step__discount">{{ level.discount }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.pro-progress-wrapper {
  padding: 0;
}

.pro-progress-track {
  position: relative;
  padding: 8px 0 0;
}

.pro-progress-line-bg,
.pro-progress-line-fill {
  position: absolute;
  top: 30px;
  left: calc(10%);
  right: calc(10%);
  height: 4px;
  border-radius: 4px;
}

.pro-progress-line-bg {
  background-color: #e9ecef;
  width: 80%;
}

.pro-progress-line-fill {
  background: linear-gradient(135deg, #38BDF8, #0B3C6B);
  max-width: 80%;
  transition: width 0.5s ease;
}

.pro-progress-steps {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.pro-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.pro-step__node {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  border: 3px solid #e9ecef;
  background: #fff;
  color: #adb5bd;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.pro-step__node i {
  font-size: 20px;
}

.pro-step--completed .pro-step__node {
  background: #1F74A8;
  border-color: #1F74A8;
  color: #fff;
  font-size: 18px;
}

.pro-step--current .pro-step__node {
  background: #1F74A8;
  border-color: #1F74A8;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(103, 64, 134, 0.18);
}

.pro-step__label {
  margin-top: 10px;
  text-align: center;
  line-height: 1.3;
}

.pro-step__name {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #495057;
}

.pro-step--completed .pro-step__name,
.pro-step--current .pro-step__name {
  color: #1F74A8;
}

.pro-step--pending .pro-step__name {
  color: #adb5bd;
}

.pro-step__discount {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  margin-top: 2px;
}

.pro-step--pending .pro-step__discount {
  color: #ced4da;
}

.pro-step--current .pro-step__discount {
  color: #1F74A8;
}

.pro-progress-info {
  margin-top: 4px;
  text-align: center;
}

.pro-current-badge {
  display: inline-block;
  background: rgba(7, 150, 149, 0.1);
  color: #1F74A8;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 13px;
}

/* Mobile */
@media (max-width: 450px) {
  .pro-step__node {
    width: 40px;
    height: 40px;
    font-size: 12px;
  }

  .pro-step--completed .pro-step__node {
    font-size: 15px;
  }

  .pro-step__name {
    font-size: 10px;
  }

  .pro-step__discount {
    font-size: 11px;
  }

  .pro-progress-line-bg,
  .pro-progress-line-fill {
    top: 25px;
  }

  .pro-progress-track {
    padding-bottom: 30px;
  }

  .pro-current-badge {
    font-size: 11px;
    padding: 4px 10px;
  }
}
</style>
